/*
 * @Author: zfd
 * @Date: 2020-09-06 10:08:57
 * @LastEditTime: 2020-09-06 11:18:42
 * @Description: 
 * @FilePath: \trip-enterprise\src\api\index.js
 */
import router from '@/router'

import axios from 'axios'


// import store from '@/store'
import { Message } from 'element-ui'

import { getToken, getCookie } from '@/common/auth'


const service = axios.create()
// 环境的切换
if (process.env.NODE_ENV == 'development') {
    service.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV == 'debug') {
    service.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV == 'production') {
    service.defaults.baseURL = '/api';
}
//request interceptor
service.interceptors.request.use(
    config => {
        //请求时带上token和userId
        let token = getToken(),
            uId = getCookie('sessionId');
        if (token) {
            config.headers['X-Token'] = token
        }
        if (uId) {
            config.headers['sessionId'] = uId
        }
        //else{
        //     Message({
        //         message: '登录信息已失效',
        //         type: 'error',
        //         duration: 5 * 1000
        //     })
        //     router.push({path:'/login'})
        // }
        return config;
    },
    error => {
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)
//response interceptor

service.interceptors.response.use(
    response => {
        try{
            if(router.history.current.path!="/login" && router.history.current.path!="/regist" && response.data.status=="TokenTimeOut")
            {
                router.push('/login');   
                throw new Error(e) ;
                      
            }
            else{
                return response.data;
            }
        }
        catch(e)
        {
            router.push('/login');     
            return;    
        }


    },
    error => {
        let errorMsg = '服务器错误';
        if (error.response.status === 404) {
            errorMsg = "请求错误"
        }
        Message({
            message: errorMsg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)
export default service